import { render, staticRenderFns } from "./vip_list.vue?vue&type=template&id=3bb5210b&scoped=true&"
import script from "./vip_list.vue?vue&type=script&lang=js&"
export * from "./vip_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb5210b",
  null
  
)

export default component.exports